import { H3HexagonLayer } from "@deck.gl/geo-layers";
import { DataFilterExtension } from "@deck.gl/extensions";
import { format } from "@/lib/numberFormatter";
import notify from "@/lib/notifications";
import debounce from "lodash/debounce";

export default class H3Layer {
  constructor({
    layer_id,
    data,
    gridFilter,
    opacity = 1,
    setPopupData,
    onGridClicked,
  }) {
    this.layer_id = layer_id;
    this.gridFilter = gridFilter;
    this.opacity = opacity;
    this.data = data;
    this.layer = this.generateLayer(data);
    this.setPopupData = setPopupData;
    this.onGridClicked = onGridClicked;
  }

  createPopupData = (info, e) => {
    const { object: grid_data, x: layerX, y: layerY } = info;
    if (grid_data && grid_data.length > 0 && grid_data[1]) {
      let value = parseFloat(grid_data[1]);
      value = isNaN(value) ? 0 : value;
      value = format(value.toFixed(0), 2);

      this.setPopupData({
        show: true,
        title: grid_data[0],
        value,
        icon: "device_hub",
        x: layerX,
        y: layerY,
      });
    } else {
      this.setPopupData({
        show: false,
      });
    }
  };

  generateLayer(data) {
    if (!(data && data.length > 0)) {
      notify.studio(
        "No GeoData",
        "The selected layer doesnt seem to have any geo data for the selected time."
      );
    }

    const colorPallet = [
      [252, 197, 192],
      [250, 159, 181],
      [247, 104, 161],
      [197, 27, 138],
      [122, 1, 119],
    ];
    // find unique values from the list of all values
    let values = [
      ...new Set(
        data.reduce((result, element) => {
          if (element[1] != 0) result.push(element[1]);
          return result;
        }, [])
      ),
    ];

    values.sort(function(a, b) {
      return a - b;
    });
    const len = values.length;
    const per20 = values[Math.floor(len * 0.25) - 1];
    const per40 = values[Math.floor(len * 0.5) - 1];
    const per60 = values[Math.floor(len * 0.75) - 1];
    const per80 = values[Math.floor(len * 1) - 1];
    let minValue, maxValue, minPercentage, maxPercentage;
    if (this.gridFilter) {
      minValue = Math.floor(len * (this.gridFilter.min / 100)) - 1;
      minPercentage = minValue < 0 ? values[0] : values[minValue];

      maxValue = Math.floor(len * (this.gridFilter.max / 100)) - 1;
      maxPercentage = maxValue < 0 ? values[0] : values[maxValue];
    }

    // percentages for legend
    this.percentages =
      per80 < 0
        ? [per20, per40, per60, per80, 0]
        : [0, per20, per40, per60, per80];
    return new H3HexagonLayer({
      id: this.layer_id,
      data: data.slice(1, data.length),
      //dataTransform: data => data.filter(item => item[1] >= minPercentage && item[1] <= maxPercentage),
      pickable: true,
      highPrecision: true,
      wireframe: false,
      filled: true,
      extruded: false,
      elevationScale: 0,
      getHexagon: d => d[0], // first element is the hexagon/grid id
      getFillColor: d => {
        const item_value = d[1] || 0;
        let color = null;
        // check if there is any filters applied
        if (item_value < per20) {
          color = colorPallet[0];
        } else if (item_value >= per20 && item_value < per40) {
          color = colorPallet[1];
        } else if (item_value >= per40 && item_value < per60) {
          color = colorPallet[2];
        } else if (item_value >= per60 && item_value < per80) {
          color = colorPallet[3];
        } else if (item_value >= per80) {
          color = colorPallet[4];
        } else {
          color = [0, 0, 0, 0];
        }

        return color;
      },
      getLineColor: () => [255, 255, 255, 0], // transparent grid border
      onHover: debounce(this.createPopupData, 100),
      onClick: (info, e) => {
        if (e.leftButton && info && info.object) {
          this.onGridClicked({
            grid_id: info.object[0],
            value: info.object[1],
          });
        }
      },
      getFilterValue: d => d[1],
      filterRange: [minPercentage, maxPercentage], // set the filter range
      extensions: [new DataFilterExtension({ filterSize: 1 })],
      opacity: this.opacity,
    });
  }

  getLayer() {
    return this.layer;
  }
}
